import { render, staticRenderFns } from "./r-smart-offer-skin-table.vue?vue&type=template&id=8304f46a"
import script from "./r-smart-offer-skin-table.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-skin-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8304f46a')) {
      api.createRecord('8304f46a', component.options)
    } else {
      api.reload('8304f46a', component.options)
    }
    module.hot.accept("./r-smart-offer-skin-table.vue?vue&type=template&id=8304f46a", function () {
      api.rerender('8304f46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/reskin/r-smart-offer-skin-table.vue"
export default component.exports